const listaRhs = [
  {
    value: "1",
    text: "O+"
  },
  {
    value: "2",
    text: "O-"
  },
  {
    value: "3",
    text: "A+"
  },
  {
    value: "4",
    text: "A-"
  },
  {
    value: "5",
    text: "B+"
  },
  {
    value: "6",
    text: "B-"
  },
  {
    value: "7",
    text: "AB+"
  },
  {
    value: "8",
    text: "AB-"
  }
]
export default listaRhs